var membership_regular = "";
var membership_special = "";
var rush_my_order = "";
var package_protection = "";

var api_url = apiDomain + "/shopify/api/index.php";

jQuery(document).ready(function () {
    fetch_settings();
    $(".onclicks").hide();
});

function fetch_settings() {
    var data = [];
    data.push({
        name: 'apiusername',
        value: apiUsername
    });
    data.push({
        name: 'apipassword',
        value: apiPassword
    });
    data.push({
        name: 'action_type',
        value: 'get_settings'
    });
    data.push({
        name: 'shopify_url',
        value: shopify_domain
    });

    $.ajax({
        url: api_url,
        dataType: 'json',
        method: "POST",
        data: data,
        cache: false,
        async: false,
        complete: function (xhr, textStatus) {
            var response = xhr.responseJSON;
            if (response != null && response.products != null) {
                membership_regular = response.products.membership_regular;
                membership_special = response.products.membership_special;
                rush_my_order = response.products.rush_my_order;
                package_protection = response.products.package_protection;

                

            }

            $("#membership_product_variant_id").val(membership_special);
            $("#membership_product2_variant_id").val(membership_special);

            $("#rush-my-order-custom").val(rush_my_order);
            $("#package-protection-custom").val(package_protection);


            console.log("membership products ids ", membership_regular, membership_special);
            clean_crm_cart();

        }
    });
}

function clean_crm_cart() {
    console.log("clean crm cart called");
    var qty_scan = 1;
    var products_added_in_cart = {};
    $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
        async: false,
        success: function (cart) {
            var vip_membership_count = 0;
            var vip_membership_special_count = 0;
            var vip_count = 0;
            $.each(cart.items, function (index, item) {
               // if (item.quantity > 1) {
                 //   changeCartFunction_CRM(item.variant_id, 1);
                 //   qty_scan = 2;
               // }
                //console.log("variant id ", item.variant_id, "special ", membership_special, "regular", membership_regular);
                if (item.title.indexOf("VIP Price") != -1) {
                    vip_count++;
                } else if (item.variant_id == membership_regular) {
                    vip_membership_count += item.quantity;
                } else if (item.variant_id == membership_special) {
                    vip_membership_special_count += item.quantity;
                }
                products_added_in_cart[item.variant_id] = item.quantity;
            });
            if (qty_scan == 2) {
                location.reload();
            }
            else
            {
                $("#main-cart-items").attr("style","");
                $("#main-cart-footer").css("visibility","visible");
            }
            console.log(products_added_in_cart);
            var has_main_product = false;
            $.each(products_added_in_cart, function (id, qty) {
                if (id == rush_my_order || id == membership_regular || id == membership_special || id == package_protection) {
                    if (qty > 1) {
                        console.log("qty setting 1", id);
                        changeCartFunction_CRM(id, 1);
                    }
                }

                //check if main product exists including special membership
                if (!(id == rush_my_order || id == membership_regular || id == package_protection)) {
                    has_main_product = true;
                }

                if (id == rush_my_order) {
                    $("#rush-my-order-custom").prop("checked", true);
                }
                if (id == package_protection) {
                    $("#package-protection-custom").prop("checked", true);
                }

            });
            if (!has_main_product) {
                $.each(products_added_in_cart, function (id, qty) {
                    console.log("cleaning product cart ", id);
                    changeCartFunction_CRM(id, 0);
                });
            }
            console.log(vip_membership_count, vip_membership_special_count, vip_count);
            if (vip_count > 0 && vip_membership_count <= 0) {
                console.log("membership regular adding 1");
                addToCartFunction_CRM(membership_regular, 1);
                vip_membership_count++;
            } else if (vip_membership_count > 0 && vip_count <= 0) {
                console.log("membership regular removing");
                changeCartFunction_CRM(membership_regular, 0);
                vip_membership_count--;
            }
            if (vip_membership_count > 0 && vip_membership_special_count > 0) {
                console.log("membership special removing");
                changeCartFunction_CRM(membership_special, 0);
            }


        }
    });
}

function check_rush_my_order(rush_my_order) {
    console.log("check_rush_my_order");
    var rushMyOrderExists = false;
    $.ajax({
        url: '/cart.js',
        dataType: "json",
        cache: false,
        async: false,
        success: function (cart) {
            console.log("cart", cart);
            $.each(cart.items, function (index, item) {
                console.log(item.variant_id);
                if (item.variant_id == rush_my_order) {
                    console.log("rmo found");
                    rushMyOrderExists = true;
                }
            });
        },
    });
    if (rushMyOrderExists) {
        $("#crm_rush_my_order_checkout").prop("checked", true);
    }
    return rushMyOrderExists;
}

function changeCartFunction_CRM(variant_id, qty, line,async_flag=false) {
    if (line == true) {
        var formData = {
            'line': variant_id,
            'quantity': qty
        };
    } else {
        var formData = {
            'id': variant_id,
            'quantity': qty
        };
    }
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: formData,
        dataType: 'json',
        cache: false,
        async: async_flag,
        success: function () {
            if (typeof loadCart === 'function') {
                // loadCart function exists
                loadCart();
                refresh_price();
            }
        }
    });
}

function addToCartFunction_CRM(variant_id, qty) {
    let formData = {
        'items': [{
            'id': variant_id,
            'quantity': qty
        }]
    };
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: formData,
        dataType: 'json',
        cache: false,
        async: false,
        success: function () {
            if (typeof loadCart === 'function') {
                // loadCart function exists
                loadCart();
                refresh_price();
            }
        }
    });
}


function custom_add_remove(checkbox_id) {

    var variant_id = $("#" + checkbox_id).val();

    console.log(" variant id ", variant_id);

    if ($("#" + checkbox_id).prop("checked")) {
        addToCartFunction_CRM(variant_id, 1);
    } else {
        changeCartFunction_CRM(variant_id, 0, false);
    }

    clean_crm_cart();
    //buildCartTotal();
    refresh_price();
    updateCartDrawer();


    // snapPixelTracking('START_CHECKOUT');
}


function buildCartTotal() {
    $.ajax({
        url: '/cart.js',
        dataType: 'json',
        success: function (cart) {

            $.each(cart.items, function (index, item) {
                console.log(index, item.title);
            });

            // Update the subtotal
            $('#custom_cart_subtotal').text("$j" + (cart.total_price / 100).toFixed(2));
        },
        error: function () {
            console.error('Error fetching cart data');
        }
    });
}

$(document).on('click', '#rush-my-order-label', function (e) {

    $("#rush-my-order-custom").trigger('click');

});

$(document).on('click', '#package-protection-label', function (e) {

    $("#package-protection-custom").trigger('click');
});


function refresh_price() {
    var data = [];


    if ($("#shipping-amount").length) {


                        
    $.ajax({
        url: "/cart.json",
        dataType: 'json',
        method: "GET",
        cache: false,
        async: true,
        complete: function (xhr) {
            try {
                xhr = xhr.responseJSON;
                $.each(xhr['items'], function (index, items) {

                    data.push({
                        name: 'cart[line_items][' + (index + 1) + '][variant_id]',
                        value: items["variant_id"]
                    });
                    data.push({
                        name: 'cart[line_items][' + (index + 1) + '][title]',
                        value: items["title"]
                    });
                    data.push({
                        name: 'cart[line_items][' + (index + 1) + '][price]',
                        value: items["price"]
                    });
                    data.push({
                        name: 'cart[line_items][' + (index + 1) + '][quantity]',
                        value: items["quantity"]
                    });

                });

                data.push({
                    name: 'apiusername',
                    value: apiUsername
                });
                data.push({
                    name: 'apipassword',
                    value: apiPassword
                });
                data.push({
                    name: 'action_type',
                    value: 'get_price'
                });
                data.push({
                    name: 'shopify_url',
                    value: shopify_domain
                });
                $('#grand-total').html('calculating...');   
                $.ajax({
                    url: api_url,
                    dataType: 'json',
                    method: "POST",
                    data: data,
                    cache: false,
                    async: true,
                    complete: function (xhr, textStatus) {
                        var response = xhr.responseJSON;


                        crm_token = response.token;
                        
                        $("#cart-subtotal").html("<span class='money'>" + Shopify.formatMoney(response.printing.sub_total, money_format) + "</span>");
                        $("#shipping-amount").html("<span class='money'>" + Shopify.formatMoney(response.printing.shipping, money_format) + "</span>");
                        $("#fees-amount").html("<span class='money'>" + Shopify.formatMoney(response.printing.fee, money_format) + "</span>");
                        $('#grand-total').html('<strong><span class="money">' + Shopify.formatMoney(response.printing.grand_total, money_format) + '</span></strong>');
                        $('#nav-grand-total').html('<strong><span class="money">' + Shopify.formatMoney(response.printing.grand_total, money_format) + '</span></strong>');


                    }
                });
            } catch (error) {

            }
        }
    });
}

}


function fetch_compare_at_price(handle,variant_id) {
   
    var compare_at_price=0;
    // Fetch product data (assuming this is an async function returning a promise)
    var product = fetchProductByHandle(handle); 
        var variant_found = null;
        // Loop through each variant to find a match
        product.variants.forEach(function (variant) {
  
            if(variant.id==variant_id)
            {
                compare_at_price = variant.compare_at_price;
            }
          
          
        });
       
        return compare_at_price;
  }